import { createAction } from 'redux-actions'

export const clearArtist = createAction('CLEAR_ARTIST')
